export const formatTaxInvoiceNumber = (corpId: string) => {
  return corpId.replace(/(\d{3})(\d{2})(\d+)/, '$1-$2-$3')
}
